// src/redux/actions/cityActions.js
import {
  FETCH_GETALLORGS_REQUEST,
  FETCH_GETALLORGS_SUCCESS,
  FETCH_GETALLORGS_FAILURE,
  SET_SELECTED_GETALLORGS,
} from '../types';
import axios from '../../API/axios';

export const fetchAllOrgsData = (searchTerm = '') => async (dispatch) => {
  dispatch({ type: FETCH_GETALLORGS_REQUEST });

  try {
    const response = await axios.get(`/MasterData/GetAllOrgsDDL?Search=${searchTerm}`);
    // console.log("getallorgs :", response);
    let getallorgsList = response.data.responseData.map((val) => {
      return {
        value: val.id,
        label: val.name,
        tagId: val.tagID
      }
    })
    dispatch({
      type: FETCH_GETALLORGS_SUCCESS,
      payload: getallorgsList,
    });
  } catch (error) {
    dispatch({
      type: FETCH_GETALLORGS_FAILURE,
      payload: error.message,
    });
  }
};

export const selectAllOrgs = (getallorgsId) => ({
  type: SET_SELECTED_GETALLORGS,
  payload: getallorgsId,
});
